<template>
  <q-card flat :style="!$q.screen.lt.md?'width: 500px; max-width: 80vw;':''">
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        {{action}}
        <span>قیمت گذاری</span> <b>{{ productInfo.Goods_Name }}</b>
        <q-badge color="red" text-color="white" :label="productInfo.Goods_Code" align="top"/>
        <template v-slot:action>
          <q-btn flat icon="close" round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-form @submit="onSubmit">
      <q-card-section class="q-gutter-sm">
        <q-field
            v-model="productInfo.List_Price"
            mask="currency"
            label="قیمت لیست"
            label-color="indigo"
            autofocus
            dir="ltr"
            filled
            dense
            clearable
        >
          <template v-slot:control="{ id, floatingLabel, value, emitValue }">
            <input :id="id" class="q-field__native text-right" :value="value"
                   @change="e => emitValue(e.target.value.replaceAll(',',''))"
                   v-money="moneyFormatForDirective"
                   v-show="floatingLabel">
          </template>
        </q-field>
        <q-field
            v-model="productInfo.Etehadie_Price"
            mask="currency"
            label="قیمت اتحادیه"
            label-color="indigo"
            autofocus
            dir="ltr"
            filled
            dense
            clearable
        >
          <template v-slot:control="{ id, floatingLabel, value, emitValue }">
            <input :id="id" class="q-field__native text-right" :value="value"
                   @change="e => emitValue(e.target.value.replaceAll(',',''))"
                   v-money="moneyFormatForDirective"
                   v-show="floatingLabel">
          </template>
        </q-field>
        <q-field
            v-model="productInfo.BuyDay_Price"
            mask="currency"
            label="قیمت خرید روز"
            label-color="indigo"
            autofocus
            dir="ltr"
            filled
            dense
            clearable
        >
          <template v-slot:control="{ id, floatingLabel, value, emitValue }">
            <input :id="id" class="q-field__native text-right" :value="value"
                   @change="e => emitValue(e.target.value.replaceAll(',',''))"
                   v-money="moneyFormatForDirective"
                   v-show="floatingLabel">
          </template>
        </q-field>
        <q-field
            v-model="productInfo.BuyLast_Price"
            mask="currency"
            label="قیمت خرید اصلی"
            label-color="indigo"
            autofocus
            dir="ltr"
            filled
            dense
            clearable
            v-if="$store.state.roles.some(v=>['admin','can_change_buy_last_price'].includes(v))"
        >
          <template v-slot:control="{ id, floatingLabel, value, emitValue }">
            <input :id="id" class="q-field__native text-right" :value="value"
                   @change="e => emitValue(e.target.value.replaceAll(',',''))"
                   v-money="moneyFormatForDirective"
                   v-show="floatingLabel">
          </template>
        </q-field>
        <q-field
            v-model="productInfo.LowLimit"
            label="درصد مانور قیمت"
            label-color="indigo"
            autofocus
            dir="ltr"
            filled
            hide-bottom-space
            dense
            @clear="productInfo.LowLimit"
            clearable>
          <template v-slot:control="{ id, floatingLabel, value, emitValue }">
            <input :id="id" class="q-field__native text-right" :value="value" type="number"
                   @change="e => emitValue(e.target.value)"
                   v-show="floatingLabel">
          </template>
        </q-field>

      </q-card-section>
      <q-card-section horizontal class="q-gutter-sm no-padding q-ml-sm q-mr-md">
        <q-field
            v-model="productInfo.Per_Min"
            label="درصد کم"
            label-color="indigo"
            autofocus
            dir="ltr"
            filled
            @clear="productInfo.Per_Min = 0"
            dense
            clearable>
          <template v-slot:control="{ id, floatingLabel, value, emitValue }">
            <input :id="id" class="q-field__native text-right" :value="value" type="number"
                   @change="e => emitValue(e.target.value)"
                   v-show="floatingLabel">
          </template>
        </q-field>
        <q-field
            v-model="productInfo.Per_Max"
            label="درصد زیاد"
            label-color="indigo"
            autofocus
            dir="ltr"
            filled
            @clear="productInfo.Per_Max = 0"
            dense
            clearable>
          <template v-slot:control="{ id, floatingLabel, value, emitValue }">
            <input :id="id" class="q-field__native text-right" :value="value" type="number"
                   @change="e => emitValue(e.target.value)"
                   v-show="floatingLabel">
          </template>
        </q-field>
        <q-field
            v-model="productInfo.Etehadie_Per"
            label="درصد اتحادیه"
            label-color="indigo"
            autofocus
            dir="ltr"
            filled
            dense
            @clear="productInfo.Etehadie_Per = 0"
            clearable>
          <template v-slot:control="{ id, floatingLabel, value, emitValue }">
            <input :id="id" class="q-field__native text-right" :value="value" type="number"
                   @change="e => emitValue(e.target.value)"
                   v-show="floatingLabel">
          </template>
        </q-field>
      </q-card-section>
      <q-card-section horizontal class="q-gutter-sm no-padding q-ml-sm q-mr-md q-mt-sm">
        <q-field
            v-model="productInfo.Goods_SaleTax_D"
            label="درصد ارزش افزوده"
            label-color="indigo"
            autofocus
            dir="ltr"
            filled
            dense
            @clear="productInfo.Goods_SaleTax_D = 0"
            clearable>
          <template v-slot:control="{ id, floatingLabel, value, emitValue }">
            <input :id="id" class="q-field__native text-right" :value="value" type="number"
                   @change="e => emitValue(e.target.value)"
                   v-show="floatingLabel">
          </template>
        </q-field>
      </q-card-section>
      <q-card-section class="text-center no-padding">
        <q-chip square color="indigo" text-color="white" label="خرید اصلی">
          <q-badge color="red" :label="parseInt(productInfo.BuyLast_Price).toLocaleString()" class="q-ml-sm"/>
        </q-chip>
        <q-chip square color="indigo" text-color="white" label="خرید روز">
          <q-badge color="red"
                   :label="productInfo.OriginalBuyDayPrice?productInfo.OriginalBuyDayPrice.toLocaleString():0"
                   class="q-ml-sm"/>
        </q-chip>
        <q-chip square color="indigo" text-color="white" label="نقد کارتن">
          <q-badge color="red"
                   :label="productInfo.SaleG_Price?productInfo.SaleG_Price.toLocaleString():0"
                   class="q-ml-sm"/>
        </q-chip>
      </q-card-section>
      <q-card-section class="text-center no-padding"
                      v-if="parseInt(productInfo.OriginalBuyDayPrice) < parseInt(productInfo.BuyLast_Price)">
        <q-chip square color="red-14"
                text-color="white"
                icon="speed"
                label="قیمت خرید روز از خرید اصلی کمتر است"/>
        <q-space/>
      </q-card-section>
      <q-card-section class="text-caption no-padding">
        <span></span>
      </q-card-section>

      <q-card-section class="text-center"
                      v-if="(productInfo.SaleG_Price < productInfo.BuyDay_Price) && productInfo.Goods_Stock">
        <q-banner class="bg-red text-white text-left" rounded>
          مبلغ نقد کارتن نمی تواند از خرید روز کمتر باشد
          <template v-slot:avatar>
            <q-avatar icon="error"/>
          </template>
        </q-banner>
      </q-card-section>
      <q-card-actions align="center">
        <q-btn label="تایید" type="submit"
               class="bg-indigo-6 text-white" icon="check"/>
        <q-btn label="انصراف" flat class="q-ml-sm" icon="cancel" color="red" v-close-popup/>
      </q-card-actions>
    </q-form>
  </q-card>

</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "GoodsPrice",
  props: {
    productInfo: {
      type: Object,
      required: false
    },
    action: {
      type: String,
    }
  },
  data() {
    return {
      moneyFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true
      },
    }
  },
  methods: {
    ...mapActions({
      updatePrice: 'Products/updateGoodsPrice'
    }),
    onSubmit() {
      this.updatePrice(this.productInfo).then((res) => this.$emit('change-price', res[0]))
    },
  },
  created() {
  }
}
</script>

<style scoped>

</style>